import {connectRoutes, NOT_FOUND, redirect} from "redux-first-router";
import createHistory from "history/createBrowserHistory";

export const CHATS = 'CHATS';
export const CHAT = 'CHAT';
export const DUMMY = 'DUMMY';
export const LOGIN = 'LOGIN';
const ROOT = 'ROOT';
export const routesMap = {
    [ROOT]: '/',
    [CHATS]: {
        path: '/chats/',
        secure: true
    },
    [CHAT]: {
        path: '/chats/:chatId',
        secure: true
    },
    [DUMMY]: '/test-client',
    [LOGIN]: '/login'
};

const availableMenuEntries = [
    {
        name: 'Chat-Admin',
        key: 'chats',
        location: "/chats"
    },
    {
        name: 'TestClient',
        key: 'testClient',
        location: "/test-client"
    },
];


const history = createHistory();

const {reducer, middleware, enhancer} = connectRoutes(history, routesMap, {
    onBeforeChange: (dispatch, getState, action) => {
        if (action.type === ROOT) {
            const _redirect = redirect({type: CHATS});
            dispatch(_redirect);
        }
        else {
            const allowed = isAllowed(action.type, getState());
            if (!allowed) {
                const action = redirect({type: 'LOGIN'});
                dispatch(action);
            }
        }

    }
});

export const pathReducer = reducer;
export const routerMiddleware = middleware;
export const routerEnhancer = enhancer;


export const navReducer = (state = {route: CHAT, availableMenuEntries}, action = {}) => {
    switch (action.type) {
        case CHATS:
        case CHAT:
            return {
                ...state,
                route: CHAT,
                selected: action.payload.chatId? action.payload.chatId: undefined,
                menu: 'chats',
            };
        case DUMMY:
            return {
                availableMenuEntries,
                route: DUMMY,
                menu: 'testClient'
            };
        case LOGIN: {
            return {
                ...state,
                route: LOGIN,
            };
        }
        case NOT_FOUND: {
            return {
                ...state,
                availableMenuEntries,
            };
        }

        default:
            return state
    }
};


const isAllowed = (type, state) => {
    const secure = routesMap[type] && routesMap[type].secure;
    if (!secure) {
        return true;
    }

    return state.auth && state.auth.authenticated;
};


// WEBPACK FOOTER //
// ./src/reducers/router.js